import { render, staticRenderFns } from "./OutroResponsavelFinanceiro.vue?vue&type=template&id=2e5795b0&"
import script from "./OutroResponsavelFinanceiro.vue?vue&type=script&lang=js&"
export * from "./OutroResponsavelFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports